// extracted by mini-css-extract-plugin
export var closeButton = "_j2-2";
export var closeButtonIcon = "_j2-3";
export var lightboxContent = "_j2-1";
export var lightboxOverlay = "_j2-0";